import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const BloggLista = lazy(() => import("@/pages/content/BloggLista"));

export const Route = createFileRoute("/blogg/")({
  head: () => seoHead("/blogg", { description: "Senaste artiklarna om elmarknaden, elpriser, solceller och energi." }),
  component: () => <BloggLista />,
});
